"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _SVGWrapper = _interopRequireDefault(require("./SVGWrapper"));

var SVGImage = function SVGImage(props) {
  return _react.default.createElement(_SVGWrapper.default, props);
};

SVGImage.propTypes = {
  image: _react.PropTypes.string
};
var _default = SVGImage;
exports.default = _default;
module.exports = exports.default;